import * as React from 'react';
import { Dayjs } from 'dayjs';
import { useTranslation } from '@/src/i18n';

type ComponentProps = {
  fromText: string;
  dateText: string;
};

const CalendarFirstAvailabilityComponent = (props: ComponentProps) => {
  const { fromText, dateText } = props;

  return (
    <>
      {fromText} <br />
      <span className="date percy-hidden">{dateText}</span>
    </>
  );
};

type Props = {
  availability: Dayjs;
};

const CalendarFirstAvailability = (props: Props) => {
  const { availability } = props;
  const { t } = useTranslation();

  if (availability.isToday()) {
    return (
      <CalendarFirstAvailabilityComponent
        fromText={t('next_availability')}
        dateText={t('today')}
      />
    );
  }

  if (availability.isTomorrow()) {
    return (
      <CalendarFirstAvailabilityComponent
        fromText={t('next_availability')}
        dateText={t('tomorrow')}
      />
    );
  }

  // other dates
  return (
    <CalendarFirstAvailabilityComponent
      fromText={t('closest_availability')}
      dateText={availability.format('dddd DD MMMM')}
    />
  );
};

export default CalendarFirstAvailability;
